.bar {
	position: sticky;
	top: 0;
	z-index: 5;
	background: var(--surface-page);
	padding: var(--space-2) 0;
	margin: 0 calc(-1 * var(--space-5));
	padding-left: var(--space-5);
	padding-right: var(--space-5);
}

.scroll {
	display: flex;
	gap: var(--space-2);
	overflow-x: auto;
	scrollbar-width: none;
}

.scroll::-webkit-scrollbar {
	display: none;
}

.trigger {
	flex: none;
	padding: 5px var(--space-3);
	border-radius: 999px;
	background: var(--surface-input);
	color: var(--ink);
	border: 1px solid color-mix(in srgb, var(--ink) 10%, transparent);
	font: inherit;
	font-size: 0.85rem;
	cursor: pointer;
	transition:
		background 0.1s ease,
		border-color 0.1s ease;
}

.trigger:hover:not(.triggerActive) {
	border-color: color-mix(in srgb, var(--ink) 22%, transparent);
}

.triggerActive {
	background: color-mix(in srgb, var(--accent-sage) 22%, transparent);
	border-color: var(--accent-sage);
	color: var(--ink);
	font-weight: 600;
}

.clearAll {
	flex: none;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 30px;
	height: 30px;
	padding: 0;
	border-radius: 999px;
	background: none;
	border: 1px solid color-mix(in srgb, var(--ink) 10%, transparent);
	color: var(--accent-rose);
	cursor: pointer;
}

.clearAll:hover {
	border-color: color-mix(in srgb, var(--accent-rose) 40%, transparent);
}
